export function RoadSignRodeoLogo() {
  return (
    <img
      src={require('./RoadSign.png')}
      className="w-36"
      alt="Road Sign Rodeo Logo"
    />
  );
}
